module.exports = __webpack_public_path__ + "img/imghuodgz-wxz.d2950b2a.png";